import { FC } from 'react';
import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { WarningIconCircle } from './styles';
import CustomModal from '@/components/CustomModal/CustomModal';
import theme from '@/theme';

interface CancelSubscriptionProps {
  open: boolean;
  handleClose: () => void;
  text: string;
  confirmButtonText: string;
  onConfirm: () => void;
  isLoading: boolean;
}

const CancelSubscriptionModal: FC<CancelSubscriptionProps> = ({
  open,
  handleClose,
  text,
  confirmButtonText,
  onConfirm,
  isLoading,
}) => {
  return (
    <CustomModal open={open} handleClose={handleClose}>
      <Stack gap="1.5rem" alignItems="center">
        <WarningIconCircle>
          <WarningAmberOutlinedIcon />
        </WarningIconCircle>
        <Typography variant="h5" fontWeight="600">
          Cancel subscription
        </Typography>
        <Typography variant="body2" color={theme.palette.neutral.greyFont} maxWidth="724px">
          {text}
        </Typography>
        <Stack flexDirection="row" gap="1.5rem" alignSelf="end">
          <Button variant="text" color="inherit" onClick={handleClose}>
            Continue with subscription
          </Button>
          <Button variant="contained" color="error" sx={{ boxShadow: 'none' }} onClick={onConfirm} disabled={isLoading}>
            {isLoading ? <CircularProgress size={24} /> : confirmButtonText}
          </Button>
        </Stack>
      </Stack>
    </CustomModal>
  );
};

export default CancelSubscriptionModal;
